<template>

<section>
<v-parallax
  :src="require('../assets/pv.png')"
>
  <v-layout
      align-center
      column
      justify-center
    >
    <h1 class="display-2 font-weight-thin mb-3">طاقة لاحدود لها</h1>
    <v-btn color="success" to="/contactform">
      اتصل بنا للحصول على تسعيره مجانية
    </v-btn>
  </v-layout>

</v-parallax>
  <v-container grid-list-xl>

  <v-layout justify-center row  v-bind="binding">
      <v-flex xs6>
        <v-card   class="elevation-0 transparent">
          <v-card-title primary-title class="layout justify-center">
            <div class="display-1">التصميم</div>
          </v-card-title>
          <v-card-text class="font-weight-medium" >
            أول خطوة في بناء المشروع الاحترافي هو التصميم عالي الكفاءة الذي يستجيب لتوقعات شركائنا بأفضل تكلفة وأكبر عوائد اقتصادية. تبني "قبس للطاقة" الثقة في شراكاتها بلغة الأرقام والحسابات الدقيقة. يقوم فريقنا بالاستجابة لمقترحات المشاريع بتقديم دراسة جدوى
            شاملة بالاعتماد على أكثر المعايير الهندسية صرامة بما يمكن شركائنا من تقدير خططهم بشكل دقيق.
          <v-btn class="headline" to="/contactform">
إحصل  على تسعيرة الآن
          </v-btn>
          </v-card-text>
        </v-card>
      </v-flex>
    <v-flex xs6>
      <v-card class="elevation-0 transparent">
        <v-img
          :src="require('../assets/design.jpg')"
        ></v-img>
      </v-card>
    </v-flex>
   </v-layout>
   <v-layout justify-center row v-bind="binding">

     <v-flex xs6 hidden-xs-only>

       <v-card class="elevation-0 transparent">

         <v-img
           :src="require('../assets/suppliers.png')"
         ></v-img>

       </v-card>

     </v-flex>

     <v-flex xs6>
       <v-card  class="elevation-0 transparent">
         <v-card-title primary-title class="layout justify-center">
           <div class="display-1">التوريد</div>
         </v-card-title>
         <v-card-text>
           تتعاون "قبس للطاقة" مع سلسلة من أبرز المصنعين العالمين في مجال الطاقة المتجددة، والذين يملكون حصص وازنة في السوقين الأوروبية والأمريكية. فريقنا يحرص على توافق مواصفات أي منتج مع جميع المعايير العالمية والتحقق من ذلك بشهادة المختبرات المتخصصة. يقوم فريقنا باختبار كل المنتجات لضمان ملائمتها للظروف المحلية وضمان تطابق المواصفات المثالية مع التشغيل الفعلي.


         </v-card-text>
       </v-card>
     </v-flex>

     <v-flex xs6 hidden-sm-only hidden-md-only hidden-lg-only hidden-x1-only>

       <v-card class="elevation-0 transparent">

         <v-img
           :src="require('../assets/suppliers.png')"
         ></v-img>

       </v-card>

     </v-flex>

    </v-layout>

    <v-layout justify-center row v-bind="binding">
        <v-flex xs6>
          <v-card  class="elevation-0 transparent">
            <v-card-title primary-title class="layout justify-center">
              <div class="display-1">التنفيذ</div>

            </v-card-title>
            <v-card-text>

  تحويل المشروع إلى حقيقة على أرض الواقع هو الشغف الذي يجمعنا في "قبس الطاقة" مع شركائنا. ولضمان تحقيق هذا الهدف بما يتوافق مع طموحاتكم، نقدم خدمات التنفيذ على يد مجموعة متخصصة من التقنيين وبإشراف هندسي مباشر.

            </v-card-text>


          </v-card>
        </v-flex>

      <v-flex xs6>

        <v-card class="elevation-0 transparent">


          <v-img
            :src="require('../assets/implementation.jpg')"
          ></v-img>

        </v-card>

      </v-flex>

     </v-layout>

    <v-layout row wrap justify-center class="my-5" v-bind="binding">
      <v-flex  xs6>
        <v-card class="elevation-0 transparent">
          <v-card-title primary-title class="layout justify-center">
            <div class="headline">معلومات الشركة</div>
          </v-card-title>
          <v-card-text>
شركة متخصصة في تصميم وتوريد وتركيب أنظمة الطاقة الشمسية
          </v-card-text>
          <div class="body-2">
            معتمدة من شركة الكهرباء السعودية في تركيب انظمة الطاقة الشمسية
          </div>
          <v-layout
            justify-center
          >
          <v-img
            :src="require('../assets/selogo.png')"
            max-width="250px"
          ></v-img>
          </v-layout>

        </v-card>
      </v-flex>
      <v-flex id="contactus" xs6 sm4 offset-sm1>
        <v-card class="elevation-0 transparent">
          <v-card-title primary-title class="layout justify-center">
            <div  class="headline">اتصل بنا</div>
          </v-card-title>

          <v-list class="transparent">

            <v-list-tile>
              <v-list-tile-action>
                <v-icon class="blue--text text--lighten-2">place</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title> المنطقة الشرقية</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-action>
                <v-icon class="blue--text text--lighten-2">email</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>sales@qabasenergy.com</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-action>
                <v-icon class="blue--text text--lighten-2">phone</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>0554205049 </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</section>
</template>

<script>
  export default {
    data: () => ({
    }),
    computed: {
      binding(){
        const binding={}
        if(this.$vuetify.breakpoint.xs) binding.column=true
        return binding

      }
    }
  }
</script>

<style lang="stylus">



</style>
